<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-md-8">
                    <competencies-crud :grid="grid" :ready="competenciesReady" @change="changed"></competencies-crud>
                </div>
                <div class="col-md-4">
                    <competencies-select :grid="grid" @ready="competenciesReady = true" @change="changed"></competencies-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CompetenciesSelect from './competencies/GridCompetenciesSelect'
    import CompetenciesCrud from './competencies/GridCompetenciesCrud'

    export default {

        components: {
            CompetenciesCrud, CompetenciesSelect
        },

        data() {
            return {
                grid: {},
                competenciesReady : false,
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.competency-grids'),
                        route: '/socrates/ui/training/competency-grids'
                    },
                    {
                        name: this.$t('common.grid') + ' ' + this.grid.name,
                    },
                ]
            }
        },

        beforeRouteEnter(to, from, next) {
            axios.get('/socrates/api/front/grids/'+to.params.id, {params: {
                relations: ['competencies']
            }})
            .then(resp => {
                next(vm => {
                    vm.grid = resp.data.data
                })
            });
        },

        methods: {
            changed() {
                axios.get('/socrates/api/front/grids/'+this.$route.params.id, {params: {
                    relations: ['competencies']
                }})
                .then(resp => {
                    this.grid = resp.data.data
                })
                .catch(err => {
                    this.$auth.handleErrorVm(err, this)
                })        
            }
        }
    }
</script>
